import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { DatePicker } from "@/components/app/DatePicker";
import { TIME_CATEGORIES, categoryLabel } from "@/lib/labels";
import { Trash } from "@phosphor-icons/react";

function TotalsGrid({ totals }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-6 gap-3 mb-4">
      <div className="border border-zinc-200 bg-white rounded p-3 col-span-2 md:col-span-1">
        <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500">Total période</div>
        <div className="font-serif-display text-2xl mt-1" data-testid="time-total">{(totals.total || 0).toFixed(1)}h</div>
      </div>
      {TIME_CATEGORIES.map((c) => (
        <div key={c.value} className="border border-zinc-200 bg-white rounded p-3">
          <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500">{c.label}</div>
          <div className="font-serif-display text-xl mt-1">{(totals[c.value] || 0).toFixed(1)}</div>
        </div>
      ))}
    </div>
  );
}

/** Liste des saisies de temps + totaux + filtres de période. */
export function TimeEntryList({ entries, totals, missionMap, filterFrom, filterTo, setFilterFrom, setFilterTo, onDelete }) {
  return (
    <div className="lg:col-span-2">
      <TotalsGrid totals={totals} />

      <div className="flex flex-wrap gap-3 mb-3 items-end">
        <div><Label>Du</Label><DatePicker value={filterFrom} onChange={setFilterFrom} testid="time-filter-from" /></div>
        <div><Label>Au</Label><DatePicker value={filterTo} onChange={setFilterTo} testid="time-filter-to" /></div>
      </div>

      <div className="border border-zinc-200 bg-white rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-zinc-50 border-b border-zinc-200">
            <tr className="text-left text-[10px] uppercase tracking-[0.18em] text-zinc-500">
              <th className="px-4 py-2">Date</th>
              <th className="px-4 py-2">Catégorie</th>
              <th className="px-4 py-2">Heures</th>
              <th className="px-4 py-2">Mission</th>
              <th className="px-4 py-2">Description</th>
              <th className="px-4 py-2"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-zinc-100">
            {entries.length === 0 && <tr><td colSpan={6} className="p-6 text-zinc-500">Aucune saisie sur la période.</td></tr>}
            {entries.map((e) => (
              <tr key={e.id} data-testid={`time-row-${e.id}`}>
                <td className="px-4 py-2">{e.date}</td>
                <td className="px-4 py-2">{categoryLabel(e.category)}</td>
                <td className="px-4 py-2">{e.hours.toFixed(2)}</td>
                <td className="px-4 py-2">{missionMap[e.mission_id]?.title || "—"}</td>
                <td className="px-4 py-2 text-zinc-600 truncate max-w-xs">{e.description || "—"}</td>
                <td className="px-4 py-2 text-right"><button onClick={() => onDelete(e.id)} className="text-zinc-500 hover:text-red-700" aria-label="Supprimer la saisie"><Trash size={16} /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
